import React, { useState, useEffect, useLayoutEffect } from "react";
import { LeadUpgradeWrapper, LeadDetailsSmallScreenWrapper } from "./LeadDetails.styled";
import { Input, Row, Col, Button, Select_, SuccessNotification, Popconfirm, Form, Modal, Upload, Collapse, Spin } from "components/common";
import { EditOutlined, HomeOutlined, PhoneOutlined, MailOutlined, UploadOutlined, UserOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { callDeleteApi, callGetApi, callPostApi, callPostApiWithAuth, callPutApi } from "utils/api";
import { getUserPermissions } from "utils/text";
import { Tabs, Popover, Menu } from "antd";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import systemImage from "../../assets/images/monitor.png";
import defaultUserImage from "../../assets/images/user.png";
import NotificationIcon from "../../assets/svg/notification.svg";
import EditIcon from "../../assets/svg/edit-icon.svg";
import moment from "moment/moment";
import LeadHistory from "components/pageSection/LeadDeatails/leadHistory/LeadHistory";
import UitilityModal from "components/pageSection/LeadDeatails/UitilityModal/UitilityModal";
import Geocode from "react-geocode";
import { getUser } from "utils/auth";
import { useDispatch } from "react-redux";
import LeadDetailsNotification from "components/pageSection/LeadDetailsNotification/LeadDetailsNotification";
import LeadsDetailsSteps from "components/pageSection/LeadsDetailsSteps/LeadsDetailsSteps";
import { TbCurrentLocationOff } from "react-icons/tb";
import { BiCurrentLocation, BiMapPin, BiLinkExternal } from "react-icons/bi";
import { FaCog, FaMapMarked } from "react-icons/fa";

const LeadDetails = () => {
    const dispatch = useDispatch();
    const { TabPane } = Tabs;
    const { Panel } = Collapse;
    let user = getUser();

    const [form] = Form.useForm();
    const history = useHistory();
    const [showEdit, setShowEdit] = useState(false);
    const [leadId, setLeadId] = useState("");
    const [details, setDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [allLocations, setAllLocations] = useState([]);
    const [allSetters, setAllSetters] = useState([]);
    const [allReps, setAllReps] = useState([]);
    const [users, setUsers] = useState([]);
    const [allStatuses, setAllStatuses] = useState([]);
    const [location, setLocation] = useState(null);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState("1");
    const [notiMessage, setNotiMessage] = useState([]);
    const [update, setUpdate] = useState(false);
    const [uitilityModal, setUitilityModal] = useState(false);
    const [lat, setLat] = useState("");
    const [lng, setLng] = useState("");
    const [editDetailsData, setEditDetailsData] = useState([]);
    const [image, setimage] = useState("");
    const [url, setUrl] = useState("");
    const [soloProposal, setSoloProposal] = useState(details?.path || '');
    const [address, setAddress] = useState("");
    const [locationImage, setLocationImage] = useState("");
    const [currentMapOptionSelection, setCurrentMapOptionSelection] = useState('fmap-view');

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [showProposal, setShowProposal] = useState(false);
    const [showProject, setShowProject] = useState(false);
    const [showLeadsHistory, setShowLeadsHistory] = useState(false);
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    const menuItems = [
        { label: 'Full Map Street View', key: 'fmap-view', icon: <TbCurrentLocationOff /> },
        { label: 'Satellite Street View', key: 'sat-view', icon: <BiCurrentLocation /> },
        { label: 'Road Map View', key: 'rdmap-view', icon: <BiMapPin /> },
        { label: 'Satellite Map View', key: 'hymap-view', icon: <FaMapMarked /> },
    ]
    const isProject = details?.install_complete || details?.install_partner || details?.loan_amount ||
        details?.financing_rate || details?.m1 || details?.m2 || details?.product || details?.financing_term ||
        details?.docRequest?.pricing?.ppw
    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 900) {
                setIsSmallScreen(true);
            } else {
                return setIsSmallScreen(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    let status_ = allStatuses?.filter((el) => el?._id?.toString() == details?.status)?.[0];
    let locationId_ = details?.locationId;
    let a = `${details?.street}, ${details?.city} , ${details?.state}`;

    let ProjectCreated = details?.dateCreated && moment(details?.dateCreated).format("MMM-DD-YYYY");

    let dateSold = details?.date_sold && moment(details?.date_sold).format("MM-DD-YYYY");
    const axs = details?.dateCreated;
    const notiOptions = [
        {
            name: "Newest",
            id: "1",
        },
        {
            name: "Oldest",
            id: "2",
        },
    ];

    const notifications = [
        {
            notification: "Heelloo There",
            name: "Asif",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
        {
            notification: "Heelloo There",
            name: "Asif",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
        {
            notification: "Heelloo There",
            name: "Asif",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
        {
            notification: "I am SkyWalker",
            name: "Lark",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
    ];
    const onClickMenu = (event) => {
        setCurrentMapOptionSelection(event.key);
        console.log(event)
        switch (event.key) {
            case 'fmap-view':
                setLocationImage(`"https://maps.googleapis.com/maps/api/streetview?size=617x617&location=${address}&key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k"`);
                break;
            case 'sat-view':
                setLocationImage(`"https://maps.googleapis.com/maps/api/streetview?size=617x617&location=${address}&heading=151.78&pitch=-0.76&key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k"`);
                break;
            case 'rdmap-view':
                setLocationImage(`"https://maps.googleapis.com/maps/api/staticmap?size=617x617&center=${address}&maptype=roadmap&zoom=18&markers=color:red|${address}&key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k"`)
                break;
            case 'hymap-view':
                setLocationImage(`"https://maps.googleapis.com/maps/api/staticmap?size=617x617&center=${address}&maptype=hybrid&zoom=18&markers=color:red|${address}&key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k"`)
                break;
        }
    }
    const onFinish = (values) => {
        postMessageApi(values);
        setUpdate(true);
    };
    const OnFinishEditForm = (values) => {
        putEditApi(values);
        setShowEdit(false);
    };
    const mySolo = () => {
        window.open(`${details?.path}`);
    };
    const proposal = () => {
        window.open(`${details?.proposal_path}`);
    };
    const callback = (key) => {
        setActiveTabKey(key);
    };
    const getbase64 = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => setimage(reader?.result);
    };
    const handelUploadPic = (file) => {
        if (file?.file?.status == "done" || file?.file?.status == "error") {
            callPostImageApi(file?.file?.originFileObj);
            getbase64(file?.file?.originFileObj);
        }
    };
    const handleOnChange = (name, value) => {
        console.log(name, value);
        setDetails((prev) => ({ ...prev, [name]: value }));
    };
    const getLead = () => {
        callGetApi(
            `/leads/${leadId}`,
            (data) => {
                setDetails(data);
                let address = `${data?.street}, ${data?.city}, ${data?.state}, ${data?.zip}`
                address = address.replace(' ', '+');
                let bgImage = `"https://maps.googleapis.com/maps/api/streetview?size=617x617&location=${address}&key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k"`
                setAddress(address)
                setLocationImage(bgImage);
                setIsLoading(false);
            },
            (err) => { }
        );
    };
    const getLocation = () => {
        callGetApi(
            "/location",
            (data) => {
                setAllLocations(data.map((e) => ({ id: e._id.toString(), name: `${e.name}, ${e.state}` })));
            },
            (err) => { }
        );
    };
    const getSetterLead = () => {
        callGetApi(
            "/leads/details/setter/leads",
            (data) => {
                setAllSetters(data.map((e) => ({ id: e._id.toString(), name: e.username })));
            },
            (err) => { }
        );
    };
    const getRepLead = () => {
        callGetApi(
            "/leads/details/rep/leads",
            (data) => {
                setAllReps(data.map((e) => ({ id: e._id.toString(), name: e.username })));
            },
            (err) => { }
        );
    };
    const getAppointment = () => {
        callGetApi(
            "/appointment",
            (data) => {
                let statues = data.map((e) => ({ id: e._id.toString(), name: e.name }));
                if (!getUserPermissions("change-status-to-sit-or-failed-credit-action")) {
                    statues = statues.filter((e) => e.name !== "Sit");
                    statues = statues.filter((e) => e.name !== "Failed Credit");
                }
                if (!getUserPermissions("change-status-to-sold-action")) {
                    statues = statues.filter((e) => e.name !== "Sold");
                }
                setAllStatuses(statues);
            },
            (err) => { }
        );
    };
    const getApis = () => {
        getLead();
        getLocation();
        getSetterLead();
        getRepLead();
        getAppointment();
    };
    const getAddress = () => {
        Geocode.fromAddress(a).then(
            (response) => {
                const { lat, lng } = response.results[0].geometry.location;
                setLat(lat);
                setLng(lng);
            },
            (error) => {
                console.error("error", error);
            }
        );
    };
    const getMessageApi = () => {
        callGetApi(
            `/notification/single/message/obj/by/${leadId}`,
            (data) => {
                let duplicate = [...data];
                let notify_ = duplicate.sort(function (a, b) {
                    return new Date(b.dateCreated) - new Date(a.dateCreated);
                });
                setNotiMessage(notify_);
                dispatch({
                    type: "SET_NOTIFICATION",
                    payload: {
                        notification: data,
                    },
                });
            },
            (err) => {
                console.log(err);
            }
        );
    };
    const callPostImageApi = (file) => {
        const formData_ = new FormData();
        formData_.append("file", file);
        callPostApi(
            `/leads/upload/image/file`,
            formData_,
            (data) => {
                setIsLoading(false);
                setUrl(data.link);
                handleOnChange("utilPic", data.link);
                SuccessNotification("Successfully Uploaded");
            },
            (err) => {
                console.log(err);
            }
        );
    };
    const sendNotificationFromSmallScreen = (data) => {
        postMessageApi({ message: data })
    }
    const postMessageApi = (data) => {
        let formData = {
            ...data,
            leadId: leadId,
        };
        callPostApiWithAuth(
            "/notification/add/lead/note",
            formData,
            () => {
                SuccessNotification("Message sent");
                getMessageApi();
            },
            (err) => {
                console.log(err);
            }
        );
    };
    const createExpenseIfSit = (stat) => {
        if (!details?.sitCalculated) {
            let payload = {
                statusId: stat.id,
                description: "Sit Pay",
                user: user.id,
                paid: false,
                lead: details?._id,
            };
            callPostApi(
                "/expenses",
                payload,
                (res) => {
                    SuccessNotification(res.message);
                    getLead();
                },
                (err) => {
                    console.log(err);
                }
            );
        } else {
            SuccessNotification("Customer Edit Successfully");
        }
    };
    const putEditApi = (data) => {
        let sat = allStatuses?.filter((el) => el.id === details?.status)[0];
        let formdata = {
            ...details,
            statusName: sat?.name,
        };
        callPutApi(
            `/leads/${leadId}`,
            formdata,
            (data) => {
                createExpenseIfSit(sat);
            },
            (err) => {
                console.log(err);
            }
        );
        setEditDetailsData(formdata);
    };
    const DeleteApi = () => {
        setIsDeleteLoading(true);
        callDeleteApi(
            `/leads/${leadId}`,
            (data) => {
                setIsDeleteLoading(false);
                SuccessNotification("Customer Deleted Successfully");
                history.push(`/leads`);
            },
            (err) => {
                setIsDeleteLoading(false);
                console.log(err);
            }
        );
    };
    const getUsersApi = () => {
        callGetApi("/user", (data) => {
            let usersData = data.map((e) => ({ id: e._id, name: e.username }));
            setUsers(usersData);
        }, (err) => { console.log(err) });
    }
    useEffect(() => {
        if (leadId) {
            setIsLoading(true);
            getApis();
        }
    }, [leadId, editDetailsData]);
    useEffect(() => {
        if (leadId) {
            getMessageApi();
        }
    }, [leadId]);
    useEffect(() => {
        if (update == true) {
            getMessageApi();
            setUpdate(false);
        }
    }, [update]);
    useEffect(() => {
        if (a) {
            Geocode.setApiKey("AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k");
            getAddress();
            Geocode.enableDebug();
        }
    }, [a]);
    useEffect(() => {
        if (details) {
            console.log(details);
        }
    }, [details]);
    useEffect(() => {
        if (showEdit) {
            form.setFieldValue("firstName", details?.firstName);
            form.setFieldValue("lastName", details?.lastName);
            form.setFieldValue("email", details?.email);
            form.setFieldValue("phone", details?.phone);
            form.setFieldValue("notes", details?.notes);
            form.setFieldValue("dateCreated", details?.dateCreated);
            form.setFieldValue("status", details?.status);
            form.setFieldValue("appointmentTime", details?.appointmentTime);
            form.setFieldValue("setter", details?.setter?._id ? details?.setter?._id : details?.setter);
            form.setFieldValue("rep", details?.rep?._id ? details?.rep?._id : details?.rep);
            form.setFieldValue("locationId", details?.locationId);
            form.setFieldValue("street", details?.street);
            form.setFieldValue("city", details?.city);
            form.setFieldValue("state", details?.state);
            form.setFieldValue("utilPic", url);
            form.setFieldValue("apptDay", details?.apptDay);
            form.setFieldValue("kw", details?.kw);
            form.setFieldValue("zip", details?.zip);
            form.setFieldValue("apptTime", details?.apptTime);
        }
    }, [showEdit]);
    useEffect(() => {
        let leadId_ = history?.location?.pathname.split("/")[2];
        if (leadId_) {
            setLeadId(leadId_);
        }
        getUsersApi();
    }, []);

    return (
        <LeadUpgradeWrapper>
            {isLoading ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: 20,
                    }}
                >
                    <Spin />
                </div>
            ) : (
                <>
                    {/* For large screen */}
                    {!showEdit && !isSmallScreen && (





                        <Row gutter={[10, 0]} style={{ marginRight: "0px" }}>


                            <Col span={24} >
                                <Row gutter={[10, 10]}>
                                    <Col span={isProject ? 12 : 24}>
                                        <Col span={24} className="lead-info">
                                            <div className="man-avatars">
                                                <UserOutlined />
                                            </div>
                                            <div className="lead-name">
                                                {details?.firstName ? (
                                                    <h6>
                                                        {details?.firstName} {details?.lastName}
                                                    </h6>
                                                ) : <h6>
                                                    {details?.customer_name.split(" ")[0]} {details?.customer_name.split(" ")[1]}
                                                </h6> ? (
                                                    <>
                                                        <h6>
                                                            {details?.first_name} {details?.last_name}{" "}
                                                        </h6>
                                                    </>
                                                ) : null}
                                            </div>
                                            <div className="man-avatars">
                                                <EditOutlined
                                                    className="button-edit"
                                                    onClick={() => {
                                                        // setEditSetter(true);
                                                        setShowEdit(true);
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col span={24} className="lead-info-container">

                                            <Row gutter={[20, 20]}>
                                                {/* {details?.firstName|| details?.lastName || details?.email || details?.customer_email || details?.phone || details?.customer_phone || details?.utilPic || details?.notes || status_?.name || details?.rep_name || details?. rep_email ?() :null} */}


                                                <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                    <Row className="main-content-row">
                                                        <Col className="details-col">
                                                            <label>Name:</label>
                                                        </Col>
                                                        <Col className="details-col">
                                                            {details?.firstName ? (
                                                                <>
                                                                    {details?.firstName} {details?.lastName}
                                                                </>
                                                            ) : (
                                                                <> {details?.customer_name}</>
                                                            )}
                                                        </Col>

                                                    </Row>
                                                </Col>
                                                {details?.email || details?.customer_email ? (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Email:</label>
                                                            </Col>
                                                            <Col className="details-col">
                                                                {details?.email ? (
                                                                    <>
                                                                        <a href="mailto:">{details?.email}</a>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <a href="mailto:">{details?.customer_email}</a>
                                                                    </>
                                                                )}
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                ) : null}
                                                {details?.phone || details?.customer_phone ? (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Phone:</label>
                                                            </Col>
                                                            <Col className="details-col">
                                                                {details?.phone ? (
                                                                    <>
                                                                        <a href={"tel:" + details?.phone}>{details?.phone}</a>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <a href={"tel:" + details?.customer_phone}>{details?.customer_phone}</a>
                                                                    </>
                                                                )}
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                ) : null}
                                                {details?.utilPic && details?.utilPic !== "null" && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Utility Bill:</label>
                                                            </Col>
                                                            <Col className="details-col">
                                                                <a href={details?.utilPic} target="_blank">
                                                                    {" "}
                                                                    View Utility Bill
                                                                </a>
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.notes && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Notes:</label>
                                                            </Col>
                                                            <Col className="details-col" id="info-notes">
                                                                {details?.notes}
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.dateCreated && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Date Created:</label>
                                                            </Col>
                                                            <Col className="details-col">{ProjectCreated}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.appointmentTime && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Appointment:</label>
                                                            </Col>
                                                            <Col className="details-col">
                                                                {details?.appointmentTime
                                                                    ? new Date(details?.appointmentTime)?.toLocaleString()
                                                                    : ""}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}

                                                {details?.rep_email && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Rep Email:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.rep_email}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.rep_name && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Rep Name:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.rep_name}</Col>
                                                        </Row>
                                                    </Col>
                                                )}

                                                {details?.date_sold && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Date Sold:</label>
                                                            </Col>
                                                            <Col className="details-col">{dateSold}</Col>
                                                        </Row>
                                                    </Col>
                                                )}



                                                {/* 2nd coulumn  */}


                                                <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                    <Row className="main-content-row">
                                                        <Col className="details-col">
                                                            <label>Status:</label>
                                                        </Col>
                                                        <Col className="details-col">{details?.statusName}</Col>

                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                    <Row className="main-content-row">
                                                        <Col className="details-col">
                                                            <label>KW:</label>
                                                        </Col>
                                                        <Col className="details-col">{details?.kw}</Col>

                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                    <Row className="main-content-row">
                                                        <Col className="details-col">
                                                            <label>Setter:</label>
                                                        </Col>
                                                        <Col className="details-col">{details?.setter?.username ? details?.setter?.username : users?.find((e) => e.id === details?.setter)?.name}</Col>

                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                    <Row className="main-content-row">
                                                        <Col className="details-col">
                                                            <label>Rep:</label>
                                                        </Col>
                                                        <Col className="details-col">{users?.find((e) => e.id === details?.rep)?.name}</Col>

                                                    </Row>
                                                </Col>

                                                {details?.setter?.name && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Setter:</label>
                                                            </Col>
                                                            <Col>
                                                                <p className="text-conatiner">{details?.setter?.name}</p>
                                                            </Col>
                                                            {getUserPermissions("setter-lead-edit-action") && (
                                                                <Col>
                                                                    <EditOutlined
                                                                        className="button-edit"
                                                                        onClick={() => {
                                                                            setShowEdit(true);
                                                                        }}
                                                                    />
                                                                </Col>
                                                            )}
                                                        </Row>
                                                        {/* )} */}
                                                    </Col>
                                                )}
                                                {details?.rep?.name && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Rep:</label>
                                                            </Col>
                                                            <Col>
                                                                {" "}
                                                                <p className="text-conatiner">{details?.rep?.name}</p>
                                                            </Col>
                                                            {/* {getUserPermissions("rep-lead-edit-action") && (
                                                                        <Col>
                                                                            <EditOutlined
                                                                                className="button-edit"
                                                                                onClick={() => {
                                                                                    setShowEdit(true);
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    )} */}
                                                        </Row>
                                                        {/* )} */}
                                                    </Col>
                                                )}

                                                {location?.name && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Location:</label>
                                                            </Col>
                                                            <Col>
                                                                {" "}
                                                                <p className="text-conatiner">{location?.name}</p>
                                                            </Col>
                                                            {/* {getUserPermissions("lead-location-action") && (
                                                                        <Col>
                                                                            <EditOutlined
                                                                                className="button-edit"
                                                                                onClick={() => {
                                                                                    setShowEdit(true);
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    )} */}
                                                        </Row>
                                                        {/* )} */}
                                                    </Col>
                                                )}
                                                {details?.kw && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">

                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>KW:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.kw}</Col>
                                                            <Col>
                                                                <EditOutlined
                                                                    className="button-edit"
                                                                    onClick={() => {
                                                                        // setEditSetter(true);
                                                                        setShowEdit(true);
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}

                                                {details?.contracts_signed && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Contract Signed:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.contracts_signed}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.street && (
                                                    <Col xs={24} sm={24} md={isProject ? 12 : 6} lg={isProject ? 12 : 6} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Address:</label>
                                                            </Col>
                                                            <Col lg={14} className="details-col">
                                                                {details?.street ? (
                                                                    <>
                                                                        <a
                                                                            href=""
                                                                            onClick={() => {
                                                                                window.open(
                                                                                    `https:www.google.com/maps/search/${details?.street}, ${details?.city} , ${details?.state}`,
                                                                                    "_blank"
                                                                                );
                                                                            }}
                                                                        >
                                                                            {details?.street}, {details?.city} ,{details?.state},
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <a
                                                                            href=""
                                                                            onClick={() => {
                                                                                window.open(
                                                                                    `https:www.google.com/maps/search/${details?.customer_address}, ${details?.customer_city} , ${details?.customer_state}`,
                                                                                    "_blank"
                                                                                );
                                                                            }}
                                                                        >
                                                                            {details?.customer_city},{details?.customer_address},
                                                                            {details?.customer_state}
                                                                        </a>
                                                                    </>
                                                                )}


                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}

                                                {/* Address */}




                                            </Row>



                                        </Col>

                                    </Col>
                                    {isProject && <Col span={12}>
                                        <Col span={24} className="lead-info">
                                            <div className="man-avatars">
                                                <HomeOutlined />
                                            </div>
                                            <div className="lead-name">
                                                <h6>
                                                    Project Info
                                                </h6>
                                            </div>
                                        </Col>
                                        <Col span={24} className="lead-info-container">
                                            <Row gutter={[20, 20]}>

                                                {details?.install_complete && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Install Complete:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.install_complete}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.install_partner && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Install Partner:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.install_partner}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.loan_amount && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Loan amount:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.loan_amount}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.financing_rate && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Financing Rate:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.financing_rate}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.m1 && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>M1:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.m1}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.m2 && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>M2:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.m2}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.product && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Product:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.product}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.financing_term && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>Financing Term:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.financing_term}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {details?.docRequest?.pricing?.ppw && (
                                                    <Col xs={24} sm={24} md={12} lg={12} className="main-border-column">
                                                        <Row className="main-content-row">
                                                            <Col className="details-col">
                                                                <label>PPW:</label>
                                                            </Col>
                                                            <Col className="details-col">{details?.docRequest?.pricing?.ppw}</Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Col>
                                    </Col>}

                                </Row>
                                <Row gutter={[20, 10]}>

                                    {/* Proposal section */}

                                    <Col xs={24} lg={24} style={{ padding: "16px 16px" }}>
                                        <Row style={{ paddingTop: "5px" }}>
                                            <Col span={24} className="lead-info-container">
                                                <Collapse className="Proposal">
                                                    <Panel
                                                        header={
                                                            <Col className="Lead-info-proposal" span={24}>
                                                                <h5>Proposal</h5>
                                                            </Col>
                                                        }
                                                    >
                                                        <Row gutter={[20, 10]}>
                                                            {details?.contracts_signed || details?.ppw ? (
                                                                <Col xs={24} sm={24} md={12} lg={12}>
                                                                    <Row gutter={[10, 10]}>
                                                                        {details?.contracts_signed && (
                                                                            <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                <label>Contract Signed:</label>
                                                                                <Row className="main-content-row">
                                                                                    <Col className="details-col">{details?.contracts_signed}</Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )}
                                                                    </Row>
                                                                </Col>
                                                            ) : null}
                                                            {/* 2nd coulumn  */}

                                                            {/* old proposal section work */}
                                                            {details?.proposal_path && (
                                                                <Col span={24} className="proposal-button-col">
                                                                    <Button
                                                                        title="Proposal"
                                                                        className="btn-background"
                                                                        onClick={() => {
                                                                            proposal();
                                                                        }}
                                                                    />
                                                                </Col>
                                                            )}

                                                            {!details?.path ? (
                                                                <Col span={24} className="proposal-button-col">
                                                                    {getUserPermissions("leads-request-proposal-action") && (
                                                                        <Row gutter={[10, 10]}>
                                                                            <Col lg={24} md={24} sm={24} xs={24}>
                                                                                <Button
                                                                                    title="Request Proposal"
                                                                                    className="btn-background"
                                                                                    onClick={() => {
                                                                                        setUitilityModal(true);
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    )}
                                                                </Col>
                                                            ) : (
                                                                <Col span={24} className="proposal-link-col">
                                                                    <Row style={{ width: "100%" }}>
                                                                        <Col span={24}>
                                                                            <Button
                                                                                title="Solo"
                                                                                onClick={() => {
                                                                                    mySolo();
                                                                                }}
                                                                                className="btn-background"
                                                                            />
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <iFrame
                                                                                src={details?.path}
                                                                                frameborder="0"
                                                                                width="100%"
                                                                                style={{
                                                                                    display: "block",
                                                                                    height: "100vh",
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Panel>
                                                </Collapse>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={24} lg={24} className="right-container" style={{ padding: "16px 16px" }}>
                                        <Row gutter={[0, 10]}>
                                            {/* <Col span={24} className="status-rescheduled-container">
                                                <Collapse className="notification-collaspe ">
                                                    <Panel
                                                        header={
                                                            <Row>
                                                                <Col span={10} className="notification-header-col">
                                                                    <h6>Notifications </h6>
                                                                </Col>
                                                                <Col span={14}>
                                                                    <Select_
                                                                        className="notification-select"
                                                                        name
                                                                        options={notiOptions}
                                                                        defaultValue="Newest"
                                                                        onChange={(e) => {
                                                                            if (e == 1) {
                                                                                let duplicate = [...notiMessage];
                                                                                let notify_ = duplicate.sort(function (a, b) {
                                                                                    return new Date(b.dateCreated) - new Date(a.dateCreated);
                                                                                });
                                                                                setNotiMessage(notify_);
                                                                            } else {
                                                                                let duplicate = [...notiMessage];
                                                                                let notify_ = duplicate.sort(function (a, b) {
                                                                                    return new Date(a.dateCreated) - new Date(b.dateCreated);
                                                                                });
                                                                                setNotiMessage(notify_);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        }
                                                        key="1"
                                                    >
                                                     
                                                    </Panel>
                                                </Collapse>
                                            </Col> */}

                                            <Col span={24} className="status-rescheduled-container">
                                                <Collapse>
                                                    <Panel
                                                        header={
                                                            <Row className="status-rescheduled-row">
                                                                {" "}
                                                                <Col span={24}>
                                                                    <h6 className="text-information">Admin Panel</h6>
                                                                </Col>
                                                            </Row>
                                                        }
                                                    >
                                                        <Col span={24} className="admin-button-col">
                                                            {getUserPermissions("lead-delete-action") && (

                                                                <Popconfirm title="Are you Sure you want to delete lead?" onConfirm={DeleteApi}>
                                                                    <Button className="btn-background" title="Delete Lead" loading={isDeleteLoading} />
                                                                </Popconfirm>

                                                            )}
                                                        </Col>
                                                    </Panel>
                                                </Collapse>
                                            </Col>

                                            <Col span={24}>
                                                <Collapse>
                                                    <Panel
                                                        header={
                                                            <Row className="status-rescheduled-row">
                                                                {" "}
                                                                <Col span={24}>
                                                                    <h6 className="text-information">Pay History</h6>
                                                                </Col>
                                                            </Row>
                                                        }
                                                    >
                                                        <Col span={24} className="admin-button-col">
                                                            <LeadHistory leadId={leadId} />
                                                        </Col>
                                                    </Panel>
                                                </Collapse>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    )}


                    {/* sdfsdf */}




























                    {/* For small screen  */}
                    {isSmallScreen && !showEdit && (
                        <LeadDetailsSmallScreenWrapper>
                            <div className="top-bg-image" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.5)), url(${locationImage})` }}>
                                {/* <div className="top-bg-image" > */}
                                <div className="mapViews">
                                    <Popover
                                        className="poping-pappu"
                                        placement="bottomLeft"
                                        style={{
                                            padding: '0 !important'
                                        }}
                                        content={
                                            <Menu
                                                theme={'light'}
                                                onClick={onClickMenu}
                                                mode="inline"
                                                selectedKeys={[currentMapOptionSelection]}
                                                items={menuItems}
                                            />
                                        } trigger="click"
                                    >
                                        <FaCog size={26} color="white" />
                                    </Popover>
                                    {/* <TbCurrentLocationOff size={26} className="normal" onClick={loadNormalMapViewImage} />
                                    <BiCurrentLocation size={26} className="satelite" onClick={loadSateliteMapViewImage} /> */}
                                </div>
                                <div className="top-bg-icons">
                                    <div className="lead-details-floating-button" onClick={() => setIsNotificationOpen(true)}>
                                        <img src={NotificationIcon} alt="notification icon" style={{ height: 22, width: 22 }} />
                                    </div>
                                    <div className="lead-details-floating-button" onClick={() => setShowEdit((prev) => !prev)}>
                                        <img src={EditIcon} alt="notification icon" style={{ height: 22, width: 22 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="leads-details-container" >
                                <div className="top-header-lead-name">
                                    <span className="top-header-lead-name-textbox">
                                        {details?.firstName} {details?.lastName}
                                    </span>
                                </div>
                                <LeadsDetailsSteps label={details?.statusName} />
                                <div className="leads-details-body">
                                    <div className="leads-details-body-field">
                                        <div className="leads-details-body-field-key">Email</div>
                                        <div className="leads-details-body-field-value">{details?.email}</div>
                                    </div>
                                    <div className="leads-details-body-field">
                                        <div className="leads-details-body-field-key">Phone</div>
                                        <div className="leads-details-body-field-value">
                                            {details?.phone ? (
                                                <a href={"tel:" + details?.phone}>{details?.phone}</a>
                                            ) : (
                                                <a href={"tel:" + details?.customer_phone}>{details?.customer_phone}</a>
                                            )}
                                        </div>
                                    </div>
                                    <div className="leads-details-body-field">
                                        <div className="leads-details-body-field-key">Utility Bills</div>
                                        <div className="leads-details-body-field-value">
                                            <a href={details?.utilPic} target="_blank">
                                                {" "}
                                                View Utility Bill
                                            </a>
                                        </div>
                                    </div>
                                    <div className="leads-details-body-field">
                                        <div className="leads-details-body-field-key">Status</div>
                                        <div className="leads-details-body-field-value">{details?.statusName}</div>
                                    </div>
                                    <div className="leads-details-body-field">
                                        <div className="leads-details-body-field-key">Date Created</div>
                                        <div className="leads-details-body-field-value">{new Date(details?.createdAt).toLocaleString()}</div>
                                    </div>
                                    {details?.appointmentTime && (
                                        <div className="leads-details-body-field">
                                            <div className="leads-details-body-field-key">Appointment</div>
                                            <div className="leads-details-body-field-value">
                                                {details?.appointmentTime ? new Date(details?.appointmentTime)?.toLocaleString() : ""}
                                            </div>
                                        </div>
                                    )}
                                    {details?.setter && (
                                        <div className="leads-details-body-field">
                                            <div className="leads-details-body-field-key">Setter</div>
                                            <div className="leads-details-body-field-value">{details?.setter?.username ? details?.setter?.username : users?.find((e) => e.id === details?.setter)?.name}</div>
                                        </div>
                                    )}
                                    {details?.rep && (
                                        <div className="leads-details-body-field">
                                            <div className="leads-details-body-field-key">Rep</div>
                                            <div className="leads-details-body-field-value">{users?.find((e) => e.id === details?.rep)?.name}</div>
                                        </div>
                                    )}
                                    {details?.notes && (
                                        <div className="leads-details-body-field">
                                            <div className="leads-details-body-field-key">Notes</div>
                                            <div className="leads-details-body-field-value">{details?.notes}</div>
                                        </div>
                                    )}
                                    {(details?.address || details?.city || details?.state) && (
                                        <div className="leads-details-body-field">
                                            <div className="leads-details-body-field-key">Address</div>
                                            <div className="leads-details-body-field-value">
                                                {details?.street + ", " + details?.city + " " + details?.state}
                                            </div>
                                        </div>
                                    )}

                                    {/* Proposal Expansion */}
                                    <div className="lead-body-expansion">
                                        <div className="lead-body-expansion-header" onClick={() => setShowProposal((prev) => !prev)}>
                                            <span className="lead-body-expansion-header-title">Proposal</span>
                                            <span className="lead-body-expansion-header-icon">
                                                {!showProposal && <RightOutlined />}
                                                {showProposal && <DownOutlined />}
                                            </span>
                                        </div>
                                        {showProposal && (
                                            <div className="lead-body-expansion-body">
                                                {details?.contracts_signed || details?.ppw ? (
                                                    <Col xs={24} sm={24} md={12} lg={12}>
                                                        <Row gutter={[10, 10]}>
                                                            {details?.contracts_signed && (
                                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                    <label>Contract Signed:</label>
                                                                    <Row className="main-content-row">
                                                                        <Col className="details-col">{details?.contracts_signed}</Col>
                                                                    </Row>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Col>
                                                ) : null}
                                                {details?.proposal_path && (
                                                    <Col span={24} className="proposal-button-col center mt-10">
                                                        <Button
                                                            title="Proposal"
                                                            style={{ width: "75%", paddingTop: "8px" }}
                                                            className="btn-background"
                                                            onClick={() => {
                                                                proposal();
                                                            }}
                                                        />
                                                    </Col>
                                                )}
                                                {!details?.path ? (
                                                    <Col span={24} className="proposal-button-col">
                                                        {getUserPermissions("leads-request-proposal-action") && (
                                                            <Row gutter={[10, 10]} className="center mt-10">
                                                                <Col lg={24} md={24} sm={24} xs={24}>
                                                                    <Button
                                                                        title="Request Proposal"
                                                                        style={{ width: "75%", paddingTop: "8px" }}
                                                                        className="btn-background"
                                                                        onClick={() => {
                                                                            setUitilityModal(true);
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </Col>
                                                ) : (
                                                    <Col span={24} className="proposal-link-col">
                                                        <Row style={{ width: "100%" }} className="center mt-10">
                                                            <Col span={24}>
                                                                <div className="solo-proposal-btn-container">
                                                                    <div className="solo-prop-btn-container">
                                                                        <button className="main-btn" onClick={() => setSoloProposal(details?.path)}>Solo</button>
                                                                        <button className="link-btn" onClick={mySolo}>
                                                                            <BiLinkExternal />
                                                                        </button>
                                                                    </div>
                                                                    <div className="solo-prop-btn-container">
                                                                        <button className={`main-btn${details?.proposal_path ? '' : ' disabled'}`} onClick={() => setSoloProposal(details?.proposal_path)}>Proposal</button>
                                                                        <button className={`link-btn${details?.proposal_path ? '' : ' disabled'}`} onClick={proposal}>
                                                                            <BiLinkExternal />
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                            <Col span={24} className="mt-2">
                                                                <iFrame
                                                                    src={soloProposal}
                                                                    frameborder="0"
                                                                    width="100%"
                                                                    style={{
                                                                        display: "block",
                                                                        height: '400px',
                                                                        border: '1px solid #cccccc',
                                                                        borderRadius: '5px'
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Projects Expansion */}
                                    {(details?.install_complete ||
                                        details?.install_partner ||
                                        details?.loan_amount ||
                                        details?.financing_rate ||
                                        details?.m1 ||
                                        details?.m2 ||
                                        details?.product ||
                                        details?.financing_term ||
                                        details?.docRequest?.pricing?.ppw) && (
                                            <div className="lead-body-expansion">
                                                <div className="lead-body-expansion-header" onClick={() => setShowProject((prev) => !prev)}>
                                                    <span className="lead-body-expansion-header-title">Projects</span>
                                                    <span className="lead-body-expansion-header-icon">
                                                        {!showProject && <RightOutlined />}
                                                        {showProject && <DownOutlined />}
                                                    </span>
                                                </div>
                                                {showProject && (
                                                    <div className="lead-body-expansion-body">
                                                        <Col xs={24} lg={24} style={{ padding: "0px 0px" }}>
                                                            <Row style={{ padding: "5px 28px 10px 28px" }}>
                                                                <Col span={24} className="main-border-column1">
                                                                    <Row gutter={[20, 20]} className="main-border-column1">
                                                                        <Col xs={24} sm={24} md={12} lg={12}>
                                                                            <Row gutter={[10, 10]}>
                                                                                {details?.install_complete && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Install Complete:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.install_complete}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.install_partner && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Install Partner:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.install_partner}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.loan_amount && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Loan amount:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.loan_amount}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.financing_rate && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Financing Rate:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.financing_rate}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                            </Row>
                                                                        </Col>
                                                                        {/* 2nd coulumn  */}
                                                                        <Col xs={24} sm={24} md={12} lg={12}>
                                                                            <Row gutter={[10, 10]}>
                                                                                {details?.m1 && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>M1</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.m1}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.m2 && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>M2</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.m2}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.product && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Product:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.product}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.financing_term && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>Financing Term:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.financing_term}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                                {details?.docRequest?.pricing?.ppw && (
                                                                                    <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                                                        <label>PPW:</label>
                                                                                        <Row className="main-content-row">
                                                                                            <Col className="details-col">{details?.docRequest?.pricing?.ppw}</Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )}
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </div>
                                                )}
                                            </div>
                                        )}


                                    {/* Pay History Expansion */}
                                    <div className="lead-body-expansion">
                                        <div className="lead-body-expansion-header" onClick={() => setShowLeadsHistory((prev) => !prev)}>
                                            <span className="lead-body-expansion-header-title">Pay History</span>
                                            <span className="lead-body-expansion-header-icon">
                                                {!showLeadsHistory && <RightOutlined />}
                                                {showLeadsHistory && <DownOutlined />}
                                            </span>
                                        </div>
                                        {showLeadsHistory && (
                                            <div className="lead-body-expansion-body">
                                                <LeadHistory leadId={leadId} />
                                            </div>
                                        )}
                                    </div>

                                    {/* Admin Panel Expansion */}
                                    <div className="lead-body-expansion">
                                        <div className="lead-body-expansion-header" onClick={() => setShowAdminPanel((prev) => !prev)}>
                                            <span className="lead-body-expansion-header-title">Admin Panel</span>
                                            <span className="lead-body-expansion-header-icon">
                                                {!showAdminPanel && <RightOutlined />}
                                                {showAdminPanel && <DownOutlined />}
                                            </span>
                                        </div>
                                        {showAdminPanel && (
                                            <div className="lead-body-expansion-body">
                                                <div className="center">
                                                    <Popconfirm title="Are you Sure you want to delete lead?" onConfirm={DeleteApi}>
                                                        <Button
                                                            style={{ width: "80%" }}
                                                            className="btn-background"
                                                            title="Delete Lead"
                                                            loading={isDeleteLoading}
                                                        />
                                                    </Popconfirm>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <LeadDetailsNotification notifications={notiMessage} sendNotification={sendNotificationFromSmallScreen} isNotificationOpen={isNotificationOpen} setIsNotificationOpen={setIsNotificationOpen} />
                        </LeadDetailsSmallScreenWrapper>
                    )}

                    {/* for small/large screen edit section */}
                    {/* ====================Edit view below========================*/}
                    {(showEdit && isSmallScreen) ||
                        (showEdit && !isSmallScreen) ? (
                        <Form name="basic" form={form} onFinish={OnFinishEditForm} autoComplete="off">
                            <Row style={{ overflowX: "hidden" }}>
                                <Col span={24} className="lead-info">
                                    <div className="man-avatars">
                                        {/* <img src={defaultMan} alt="" /> */}
                                        <UserOutlined />
                                    </div>
                                    <div className="lead-name">
                                        <label>Lead</label>
                                        <h6>
                                            {details?.firstName} {details?.lastName}
                                        </h6>
                                    </div>
                                </Col>
                                <Col span={24} className="lead-info-container">
                                    <Row gutter={[20, 20]}>
                                        <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "0px 20px" }}>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>First Name:</label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="firstName">
                                                                <Input
                                                                    value={details?.setter}
                                                                    onChange={(e) => handleOnChange("firstName", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Last Name:</label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="lastName">
                                                                <Input
                                                                    value={details?.lastName}
                                                                    onChange={(e) => handleOnChange("lastName", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>
                                                        Email:
                                                        {<MailOutlined style={{ marginLeft: "7px" }} />}
                                                    </label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="email">
                                                                <Input
                                                                    value={details?.email}
                                                                    onChange={(e) => handleOnChange("email", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>
                                                        Phone:
                                                        {<PhoneOutlined style={{ marginLeft: "7px" }} />}
                                                    </label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="phone">
                                                                <Input
                                                                    value={details?.phone}
                                                                    onChange={(e) => handleOnChange("phone", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Notes:</label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="notes">
                                                                <Input
                                                                    value={details?.notes}
                                                                    onChange={(e) => handleOnChange("notes", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>KW:</label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="kw">
                                                                <Input
                                                                    value={details?.kw}
                                                                    onChange={(e) => handleOnChange("kw", e.target.value)}
                                                                    type="text"
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "0px 20px" }}>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Status:</label>
                                                    <Row className="main-content-row">
                                                        <Col className="edit-details-col" span={24}>
                                                            <Form.Item name="status">
                                                                <Select_
                                                                    value={details?.status}
                                                                    onChange={(e) => handleOnChange("status", e)}
                                                                    options={allStatuses}
                                                                    name
                                                                    showSearch
                                                                    disabled={details?.sitCalculated}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Setter:</label>

                                                    <Row>
                                                        <Col span={24} className="edit-details-col">
                                                            {" "}
                                                            <Form.Item name="setter">
                                                                <Select_
                                                                    value={details?.setter}
                                                                    onChange={(e) => handleOnChange("setter", e)}
                                                                    options={allSetters}
                                                                    name
                                                                    showSearch
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Rep:</label>

                                                    <Row>
                                                        <Col className="edit-details-col" span={24}>
                                                            {" "}
                                                            <Form.Item name="rep">
                                                                <Select_
                                                                    value={details?.rep}
                                                                    onChange={(e) => handleOnChange("rep", e)}
                                                                    options={allReps}
                                                                    name
                                                                    showSearch
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Location:</label>

                                                    <Row>
                                                        <Col className="edit-details-col" span={24}>
                                                            {" "}
                                                            <Form.Item name="locationId">
                                                                <Select_
                                                                    value={details?.locationId}
                                                                    onChange={(e) => handleOnChange("locationId", e)}
                                                                    options={allLocations}
                                                                    name
                                                                    showSearch
                                                                    className="edit-inputs"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} className="main-border-column">
                                                    <label>Utility Bill:</label>
                                                    <Row>
                                                        <Col className="edit-details-col" span={24} style={{ height: "60px" }}>
                                                            <Form.Item name="utilPic">
                                                                <Upload showUploadList={false} onChange={handelUploadPic}>
                                                                    <Button
                                                                        className="upload-Btn"
                                                                        title="Upload Utility Bill"
                                                                        Icon={<UploadOutlined />}
                                                                        style={{
                                                                            display: "flex",
                                                                        }}
                                                                    />
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24} style={{ padding: "0px 20px" }}>
                                    <Collapse defaultActiveKey={["1"]} style={{ marginTop: "15px" }}>
                                        <Panel header="Address Information" key="1">
                                            <Row>
                                                <Col span={24} className="address-info">
                                                    <Row className="main-border-column">
                                                        <Col span={24}>
                                                            <label style={{ fontSize: "17px" }}>
                                                                Address
                                                                {
                                                                    <HomeOutlined
                                                                        style={{
                                                                            marginLeft: "7px",
                                                                            marginTop: "-5px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    />
                                                                }
                                                            </label>

                                                            <Row className="main-content-row" gutter={[10, 10]}>
                                                                <Col span={12}>
                                                                    <label className="edit-collaspe-label">Street:</label>
                                                                    <Form.Item name="street">
                                                                        <Input
                                                                            value={details?.street}
                                                                            onChange={(e) => handleOnChange("street", e.target.value)}
                                                                            type="text"
                                                                            className="edit-inputs"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col className="edit-details-collaspe-col" span={12}>
                                                                    <label className="edit-collaspe-label">City:</label>
                                                                    <Form.Item name="city">
                                                                        <Input
                                                                            value={details?.city}
                                                                            onChange={(e) => handleOnChange("city", e.target.value)}
                                                                            type="text"
                                                                            className="edit-inputs"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>{" "}
                                                                <Col span={12}>
                                                                    <label className="edit-collaspe-label">State:</label>
                                                                    <Form.Item name="state">
                                                                        <Input
                                                                            value={details?.state}
                                                                            onChange={(e) => handleOnChange("state", e.target.value)}
                                                                            type="text"
                                                                            className="edit-inputs"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </Col>
                                <Col span={24} style={{ paddingTop: "10px" }}>
                                    <Row gutter={[15, 15]}>
                                        <Col span={12}>
                                            <Button
                                                id="btn-end"
                                                title="Cancel"
                                                onClick={() => {
                                                    setShowEdit(false);
                                                }}
                                                style={{
                                                    background: "#131f28",
                                                    fontsize: "16px",
                                                    color: "white",
                                                    border: "0 none",
                                                    borderradius: "3px",
                                                    cursor: "pointer",
                                                    border: "2px solid transparent",
                                                    width: "100%",
                                                    height: "51px",
                                                    paddingbottom: "35px",
                                                    paddingtop: "12px",
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Col>
                                        <Col span={12} className="btn-end">
                                            <Form.Item>
                                                <Button
                                                    title="Save"
                                                    id="btn-end"
                                                    htmlType="submit"
                                                    style={{
                                                        background: "#131f28",
                                                        fontsize: "16px",
                                                        color: "white",
                                                        border: "0 none",
                                                        borderradius: "3px",
                                                        cursor: "pointer",
                                                        border: "2px solid transparent",
                                                        width: "100%",
                                                        height: "51px",
                                                        paddingbottom: "35px",
                                                        paddingtop: "12px",
                                                    }}
                                                >
                                                    Save
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    ) : null}
                    <Modal
                        title="Select Utility Company Modal"
                        isOpen={uitilityModal}
                        toggleModal={() => {
                            setUitilityModal(false);
                        }}
                        onOk={() => {
                            setUitilityModal(false);
                        }}
                        footer={false}
                    >
                        <UitilityModal
                            details={details}
                            lat={lat}
                            lng={lng}
                            setLat={setLat}
                            setLng={setLng}
                            leadId={leadId}
                            setUitilityModal={setUitilityModal}
                            locationId_={locationId_}
                        />
                    </Modal>
                </>
            )}
        </LeadUpgradeWrapper>
    );
};

export default LeadDetails;
